export const NAME = 'companyRoles';
export const ROLE_LEVELS = {
    OWNER: 0,
    ADMIN: 1,
    CUSTOM: 3,
};
